export enum ReferenceTaskVisibility {
    INTERNAL = 'Internal',
    EXTERNAL = 'External',
}
